import React from 'react'
import "./RevenueComponent.css";
import { Tooltip } from 'react-tooltip';

const RevenueCard = ({ head = "Total Earnings", value, balText = null, valueBold = false, icon = null ,data  ,infoText}) => {    
    return (
        <div className="revenue-card border border-[#d9d9d9] rounded-md flex flex-col justify-center">
            <div className="flex justify-between items-center">
                <h5 className="revenue-card-head">{head}</h5>
                {icon ?
                    <img src={icon} alt="Earnings-icon" /> : <></>}
            </div>
            <div>
                <div>
                    <p className={`revenue-card-value ${valueBold ? 'font-semibold text-black' : 'font-normal text-[#555555]'}`} >{data?.currency_symbol || ""}{value}</p>
                    {balText ?
                        <div className='flex justify-between items-center'>
                            <p className="bal-text">{balText}</p>
                            <span data-tooltip-id="info-tooltip" className='cursor-pointer'
                            >
                            
                            </span>
                        </div> : <></>}
<div style={{ display: "flex", justifyContent: "flex-end" }}>                        {
                            infoText &&
                                                        <span data-tooltip-id="info-tooltip" className='cursor-pointer'>
                                                                <svg width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.725 3.9675C7.875 3.8325 8.055 3.75 8.25 3.75C8.4525 3.75 8.625 3.8325 8.7825 3.9675C8.925 4.125 9 4.305 9 4.5C9 4.7025 8.925 4.875 8.7825 5.0325C8.625 5.175 8.4525 5.25 8.25 5.25C8.055 5.25 7.875 5.175 7.725 5.0325C7.5825 4.875 7.5 4.7025 7.5 4.5C7.5 4.305 7.5825 4.125 7.725 3.9675ZM5.85 7.4775C5.85 7.4775 7.4775 6.1875 8.07 6.135C8.625 6.09 8.5125 6.7275 8.46 7.0575L8.4525 7.1025C8.3475 7.5 8.22 7.98 8.0925 8.4375C7.8075 9.48 7.53 10.5 7.5975 10.6875C7.6725 10.9425 8.1375 10.62 8.475 10.395C8.52 10.365 8.5575 10.335 8.595 10.3125C8.595 10.3125 8.655 10.2525 8.715 10.335C8.73 10.3575 8.745 10.38 8.76 10.395C8.8275 10.5 8.865 10.5375 8.775 10.5975L8.745 10.6125C8.58 10.725 7.875 11.22 7.59 11.4C7.2825 11.6025 6.105 12.2775 6.285 10.965C6.4425 10.0425 6.6525 9.2475 6.8175 8.625C7.125 7.5 7.26 6.99 6.57 7.4325C6.2925 7.5975 6.1275 7.7025 6.03 7.77C5.9475 7.83 5.94 7.83 5.8875 7.7325L5.865 7.6875L5.8275 7.6275C5.775 7.5525 5.775 7.545 5.85 7.4775ZM15 7.5C15 11.625 11.625 15 7.5 15C3.375 15 0 11.625 0 7.5C0 3.375 3.375 0 7.5 0C11.625 0 15 3.375 15 7.5ZM13.5 7.5C13.5 4.185 10.815 1.5 7.5 1.5C4.185 1.5 1.5 4.185 1.5 7.5C1.5 10.815 4.185 13.5 7.5 13.5C10.815 13.5 13.5 10.815 13.5 7.5Z" fill="#252525" />
                                </svg>

                             <Tooltip id="info-tooltip" place="top" style={{ width: '200px' }} content={"If the Payout is in Process, there might be a difference between Course Revenue and Available to Withdraw."} />
                            </span>

                        }
                        </div>
                </div>

            </div>
        </div>
    )
}

export default RevenueCard